import { type HttpClientConfig } from 'core/infra/http/HttpClient'

import { createAgnosticHttpClient } from 'auth/infra/createAgnosticHttpClient'

import { type OpenDockWarehouseFormFields } from '../infra/ShipmentMapper'
import { ShipmentRepository } from '../infra/ShipmentRepository'
import { type ScheduleFormValues } from '../ui/OpenDockAppointmentDrawer/Schedule'

type CreateOpenDockWarehouseAppointmentFactoryDependencies = {
  repository: ShipmentRepository
}

type Params = {
  shipmentUUID: string
  stopIndex: number
  params: {
    staticFields: ScheduleFormValues
    warehouseFormFields: OpenDockWarehouseFormFields
    openDockCarrierId: string | undefined
    facilityTimezone: string
  }
  config: Partial<HttpClientConfig>
}

export function createOpenDockWarehouseAppointmentFactory({
  repository,
}: CreateOpenDockWarehouseAppointmentFactoryDependencies) {
  return async function createOpenDockWarehouseAppointment({
    shipmentUUID,
    stopIndex,
    params,
    config,
  }: Params) {
    try {
      return await repository.createOpenDockWarehouseAppointment(
        shipmentUUID,
        stopIndex,
        params,
        config
      )
    } catch (error) {
      throw new Error('Could not create OpenDock warehouse appointment', { cause: error as Error })
    }
  }
}

export function createOpenDockWarehouseAppointment({
  shipmentUUID,
  stopIndex,
  params,
  config,
}: Params) {
  const httpClient = createAgnosticHttpClient()
  const repository = new ShipmentRepository({ httpClient })
  const newCreateOpenDockWarehouseAppointment = createOpenDockWarehouseAppointmentFactory({
    repository,
  })
  return newCreateOpenDockWarehouseAppointment({ shipmentUUID, stopIndex, params, config })
}
